//import './results-filter';
//import './search-dropdown';
import './global-search';



// WEBPACK FOOTER //
// ./client/src/site__scf001/components/search/index.js